import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SharedModule } from 'shared/shared.module';
import { FormModule } from 'shared/form/form.module';
import { ReceiversRoutingModule } from './receivers-routing.module';
import { ReceiverActionsModule } from './components/receiver-actions/receiver-actions.module';
import { ReceiverLogsModule } from './components/receiver-logs/receiver-logs.module';

import { ScrollToService } from 'shared/base/scroll-to.service';
import { SearchPageService } from 'shared/search-page/search-page.service';
import { SideDrawerService } from 'shared/sidedrawer/sidedrawer.service';

import { ReceiversComponent } from './receivers.component';
import { ReceiversHeaderComponent } from './components/receivers-header/receivers-header.component';
import { ReceiversSearchComponent } from './components/receivers-search/receivers-search.component';
import { ReceiverDetailsTabComponent } from './components/receiver-details/receiver-details.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        FormModule,
        ReceiversRoutingModule,
        ReceiverActionsModule,
        ReceiverLogsModule,
    ],
    declarations: [
        ReceiversComponent,
        ReceiversHeaderComponent,
        ReceiversSearchComponent,
        ReceiverDetailsTabComponent,
    ],
    exports: [ReceiversComponent],
    providers: [
        ScrollToService,
        SearchPageService,
        SideDrawerService,
    ]
})
export class ReceiversModule {}
